import { FC, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { Card, CardBody, Col, Row } from 'reactstrap';
import { BasicPerson } from 'types';
import { parseAndFormatQuestionResponse } from 'utils/models/Performance';
import RichTextViewer from 'views/Widgets/Inputs/RichTextViewer';
import { INPUT_TYPES } from 'views/Widgets/Inputs/ValidatedInputTypes';
import Avatar from 'views/Widgets/People/Avatar';
import { PrivateDataBadge } from '../components/PrivateDataBadge';
import { WrittenResponse } from './utils';

export interface Props {
  question: WrittenResponse;
  person: BasicPerson;
  key: string;
  isInReviewFlow?: boolean;
}

export const PerformanceWrittenMultiResponse: FC<Props> = (props: Props) => {
  const { formatMessage, locale } = useIntl();
  const q = useMemo(() => props.question, [props.question]);

  if (q.question?.type?.toUpperCase() === INPUT_TYPES.SECTION) {
    return (
      <h3 className="header-title mb-3">
        <RichTextViewer model={q.question.label} expanded={true} />
      </h3>
    );
  }

  return (
    <Card key={props.key}>
      <CardBody>
        <h4 className="mb-3">
          <RichTextViewer model={q.title} expanded={true} />
          {q.question?.hide_from_recipient && !props.isInReviewFlow && (
            <PrivateDataBadge className="mt-2" />
          )}
        </h4>
        {q.responses.map((r, index) => (
          <Row key={index} className="flex-nowrap mt-4">
            <Col className="col-auto">
              <Avatar size="sm" person={r.person} />
            </Col>
            <Col className="ms-n3">
              <div>
                <div
                  className="comment-body d-block px-3"
                  style={{ paddingTop: '0.5rem', paddingBottom: '0.5rem' }}
                >
                  <Row>
                    <Col>
                      <div className="mb-0 py-1">
                        <div>
                          <div className="fr-view">
                            <p className="">
                              {parseAndFormatQuestionResponse({
                                q: r,
                                locale,
                                formatMessage,
                              })}
                            </p>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>
          </Row>
        ))}
      </CardBody>
    </Card>
  );
};
